import { createAction, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ActionType, WizardState, SelectionType } from "./types";

export const handleSetSelection = createAction(
  "wizard/handleSetSelection",
  (selection: SelectionType) => ({ payload: selection })
);

export const handleToggleCheckout = createAction(
  "wizard/handleToggleCheckout",
  (payload: boolean) => ({ payload })
);

const initialState: WizardState = {
  type: ActionType.Individual,
  selection: {},
  checkout: false,
  years: 1,
};

export const wizardSlice = createSlice({
  name: "wizard",
  initialState,
  reducers: {
    setType: (state, action: PayloadAction<ActionType>) => {
      return {
        ...state,
        type: action.payload,
      };
    },
    setSelection: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        selection: action.payload,
      };
    },
    toggleCheckout: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        checkout: action.payload,
      };
    },
    resetWizard: (state) => {
      return {
        ...state,
        selection: {},
        checkout: false,
      };
    },
    setYears: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        years: action.payload
      };
    },
    resetYears: (state) => {
      return {
        ...state,
        years: 1
      };
    }
  },
});

export const {
  setType,
  setSelection,
  toggleCheckout,
  resetWizard,
  setYears,
  resetYears,
} = wizardSlice.actions;

export default wizardSlice.reducer;
